import client from '../../providers/fetchClient'

export const login = credentials => client.post('/v3/users/login', credentials)

export const fetchCurrentUser = () => client.get('/v3/me')
